<template>
  <div style="height: 100%; color: #FAFAFA;">
    <label style="padding: 20px 0px 10px 30px;">漏水设备</label>
    <div v-if="deviceDataList.length > 0" style="height: 85%">
      <!-- 2个及以下设备直接显示 -->
      <template v-if="pageList.length === 1">
        <el-row style="height: 100%;">
          <el-col :span="12" v-for="device in pageList[0]" :key="device.deviceName" class="text-center">
            <el-row>
              <label :style="{ lineHeight: '3vh', color: (device.status !== undefined && device.status !== 0) ? '#ff0000' : '#fff' }">
                {{ device.deviceName }}
              </label>
            </el-row>
            <div v-for="(point, pIndex) in device.points" :key="pIndex">
               <el-row style="margin-top: 1vh;">
                <!-- <el-col :span="14" class="text-right text-blueGrey">{{ point.name }}：</el-col> -->
                <el-col :span="14" class="text-right text-blueGrey" style="width: 100px;">&nbsp; </el-col>
                <el-col :span="8" class="text-left" :style="{ marginLeft: '10px', color: point.color }">{{ point.value }}</el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </template>
      <!-- 超过2个设备使用轮播 -->
      <template v-else>
        <el-carousel 
          :interval="10000" 
          indicator-position="none" 
          :autoplay="true" 
          style="height: 100%; z-index: 0">
           <el-carousel-item v-for="(page, index) in pageList" :key="index">
            <el-row style="height: 100%;">
              <el-col :span="12" v-for="device in page" :key="device.deviceName" class="text-center">
                 <el-row>
                  <label :style="{ lineHeight: '3vh', color: (device.status !== undefined && device.status !== 0) ? '#ff0000' : '#fff' }">
                    {{ device.deviceName }}
                  </label>
                </el-row>
                <div v-for="(point, pIndex) in device.points" :key="pIndex">
                  <el-row style="margin-top: 1vh;">
                    <!-- <el-col :span="14" class="text-right text-blueGrey">{{ point.name }}：</el-col> -->
                    <el-col :span="14" class="text-right text-blueGrey" style="width: 100px;">&nbsp; </el-col>
                    <el-col :span="8" class="text-left" :style="{ marginLeft: '10px', color: point.color }">{{ point.value }}</el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <div v-else style="height: 100%; padding-top: 20%">
      <no-data></no-data>
    </div>
  </div>
</template>

<script>
import NoData from "@/components/NoData";
import { getSpecialTypeValues } from "@/network/measuring-point-history";

export default {
  name: "controlRoomWaterLeak",
  components: { NoData },
  data() {
    return {
      deviceDataList: [],
      pageList: [],
      pageSize: 2, 
      deviceType: 'PM_WLD', 
      pointCodes: 'di5,di1' 
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', { 'getWaterLeakData:10000': this.getData })
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getWaterLeakData')
  },
  methods: {
    getData() {
      getSpecialTypeValues(this.deviceType, this.pointCodes).then(res => {
        if (res.code === 0 && res.data) {
          const { devices, devicePointValues, devicePointNames } = res.data;
          if (devices && devices.length > 0) {
            this.deviceDataList = this.processData(devices, devicePointValues, devicePointNames);
            if (this.deviceDataList.length > 0) {
              this.pageList = this.chunkData(this.deviceDataList, this.pageSize);
            } else {
              this.pageList = [];
            }
          } else {
            this.deviceDataList = [];
            this.pageList = [];
          }
        } else {
          this.deviceDataList = [];
          this.pageList = [];
        }
      }).catch(() => {
        this.deviceDataList = [];
        this.pageList = [];
      });
    },
    processData(devices, devicePointValues, devicePointNames) {
      const result = [];
      const pointCodeList = this.pointCodes.split(',');
      const defaultNames = pointCodeList.map(code => code.toUpperCase());

      for (let i = 0; i < devices.length; i++) {
        const device = devices[i];
        const values = devicePointValues[i];
        const currentDevicePointNames = (devicePointNames && devicePointNames[i]) ? devicePointNames[i] : defaultNames;

        if (device && values) {
          const points = [];
          
          values.forEach((val, index) => {
             // Use explicit device names if available, otherwise default
             let displayValue = val;
             let color = '#fff';

             if (val === 1 || val === '1') {
                displayValue = '正常';
                color = '#00ff00';
             } else if (val === 0 || val === '0') {
                displayValue = '告警';
                color = '#ff0000';
             } else if (displayValue === null || displayValue === undefined) {
                displayValue = '--';
             }
             
             points.push({
                 name: currentDevicePointNames[index] || defaultNames[index] || '未知点位',
                 value: displayValue,
                 color: color
             });
          });

          result.push({
            deviceName: device.name || '未知设备',
            status: device.status,
            points: points
          });
        }
      }
      return result;
    },
    chunkData(data, size) {
      const result = [];
      for (let i = 0; i < data.length; i += size) {
        result.push(data.slice(i, i + size));
      }
      return result;
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
  color: #01EFFD;
}
.text-blueGrey {
    color: #aeaeae; 
}
</style>